import axios from "axios";

const actions = {
  //   async login({ commit }, payload) {
  //     const axiosInstance = axios.create();
  //     try {
  //       const { data } = await axiosInstance.post(
  //         process.env.VUE_APP_SIGNIN_API_URL,
  //         payload
  //       );
  //       commit("SET_CURRENT_USER", data);
  //       commit("SET_CURRENT_CONTEXT", data.product);
  //     } catch (error) {
  //       console.log(error);
  //       throw error;
  //     }
  //   },
  async loginODIC({ commit }, payload) {
    const axiosInstance = axios.create();
    try {
      const { data } = await axiosInstance.post(
        process.env.VUE_APP_ODICSIGNIN_API_URL,
        payload
      );
      console.log(data);
      commit("SET_CURRENT_USER", data);
    } catch (error) {
      console.log(error);
      throw error;
    }
  }
  //   async logout({ commit }) {
  //     try {
  //       await axios.delete(process.env.VUE_APP_SIGNOUT_API_URL);
  //       commit("CLEAR_CURRENT_USER");
  //       commit("CLEAR_CURRENT_CONTEXT");
  //     } catch (error) {
  //       console.log(error);
  //       throw error;
  //     }
  //   }
};

export default actions;
